import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { RoomModel, RoomUpdate } from 'types/api'

export function useUpdateRoom() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function updateRoom({ id, ...args }: { id: string } & RoomUpdate) {
    const res = await apiClient.patch<RoomModel>(`/api/v1/rooms/${id}`, args)
    return res.data
  }

  return useMutation({
    mutationFn: updateRoom,
    onSuccess: () => {
      toast.success({ message: t('roomUpdated') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError
  })
}
